export const safeJsonParse = <T = unknown>(str: string): T | undefined => {
  try {
    const jsonValue: T = JSON.parse(str) as T;
    return jsonValue;
  } catch {
    return;
  }
};
